export const isNumeric = (value: string | undefined): boolean => value !== undefined && /^[-]?\d+$/.test(value);

export const replaceAll = (string: string, searchValue: string, newValue: string): string =>
  string.split(searchValue).join(newValue);
